let input = document.querySelector('#select-office');

let MOBILE_THRESHOLD = 544;

let containerWidth = document.getElementsByClassName('results-container')
  .offsetWidth;

let isMobile = containerWidth <= MOBILE_THRESHOLD ? true : false;

var selectedItem = sessionStorage.getItem('SelectedItem');
if (selectedItem) {
  document.getElementById('select-office').value = selectedItem;
}

input.addEventListener('change', function() {
  const elem = document.getElementById(this.value);
  sessionStorage.setItem('SelectedItem', this.value);

  scrollIt(elem);
});

function scrollIt(element) {
  const y =
    element.getBoundingClientRect().top +
    window.pageYOffset -
    (isMobile ? 115 : 75);

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: y,
  });
}

// Added a function to tell when the sticky bar is stuck so that we can hide the "See who's running for:" for mobile.

const observer = new IntersectionObserver(
  ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(document.querySelector('#sticky-bar'));
